import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import searchFilterTerms from "@tKgpco/Handlers/Terms/SearchFilterTerms";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { QuoteTermsFormValues } from "@tKgpco/Store/Data/Terms/TermsState";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomApplicationState) => ({
    pagination: state.KGPState.customTerms.pagination,
    selectFilter: state.KGPState.customTerms.selectFilter,
    selectFilterText: state.KGPState.customTerms.selectFilterText,
});

const mapDispatchToProps = {
    searchFilterTerms,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface TermsPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const TermsPaginationStyles: TermsPaginationStyles = {};

const styles = TermsPaginationStyles;

const TermsPagination = ({ searchFilterTerms, pagination, selectFilter, selectFilterText }: Props) => {

    if (!pagination) {
        return null;
    }
    const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
    useEffect(() => {
        if (shouldScrollToTop) {
            window.scrollTo(0, 0);
            setShouldScrollToTop(false);
        }
    }, [pagination?.page]);

    const { totalItemCount, page, pageSize, pageSizeOptions, prevPageUri, nextPageUri } = pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        searchFilterTerms({ queryParams: { page: newPageIndex, [selectFilter as keyof QuoteTermsFormValues]: selectFilterText } });
        setShouldScrollToTop(true);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={prevPageUri}
            nextPage={nextPageUri}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TermsPagination),
    definition: {
        displayName: "Terms Pagination",
        group: "Basic",
    },
};

export default widgetModule;
